module.exports = __webpack_public_path__ + "img/igive_hjem_header.9e11c1a5.png";